import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const setStatusCommand = (production_center, identifiers, orderName) => {
    const params = {
      model: `Restaurant Object`,
      name: production_center,
      method: `set_status_command`,
      args: JSON.stringify({
        identifiers,
        order_name: orderName,
      }),
    };
    try {
      return axios.post(`method/frappe_helper.api.call`, params);
    } catch (err) {
      throw new err();
    }
  };
  //
  export const useSetStatusCommand = () => {
    return useMutation(async ({ production_center, identifiers, orderName }) => {
      const data = await setStatusCommand(production_center, identifiers, orderName);
      return data;
    });
  };
  